import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/surgery-doctors")({
  beforeLoad: () => {
    throw redirect({ to: "/doctors", replace: true, statusCode: 301 });
  },
});
